
const CHANGE_IN_DEPENDANTS_MODAL = 'CHANGE_IN_DEPENDANTS_MODAL';
const CHANGE_IN_IMMIGRATION_STATUS_MODAL = 'CHANGE_IN_IMMIGRATION_STATUS_MODAL';
const CHANGE_IN_INCARCERATION_STATUS_MODAL = 'CHANGE_IN_INCARCERATION_STATUS_MODAL';
const CHANGE_IN_INCOME_MODAL = 'CHANGE_IN_INCOME_MODAL';
const CHANGE_OF_ADDRESS_MODAL = 'CHANGE_OF_ADDRESS_MODAL';
const DEATH_MODAL = 'DEATH_MODAL';
const DENIED_MEDICAID_CHIP_MODAL = 'DENIED_MEDICAID_CHIP_MODAL';
const DIVORCE_AND_SEPARATION_MODAL = 'DIVORCE_AND_SEPARATION_MODAL';
const LOSS_COVERAGE_MODAL = 'LOSS_COVERAGE_MODAL';
const MARRIAGE_MODAL = 'MARRIAGE_MODAL';
const NATIVE_AMERICANS_MODAL = 'NATIVE_AMERICANS_MODAL';


export const lceModalTypes = {
    CHANGE_IN_DEPENDANTS_MODAL,
    CHANGE_IN_IMMIGRATION_STATUS_MODAL,
    CHANGE_IN_INCARCERATION_STATUS_MODAL,
    CHANGE_IN_INCOME_MODAL,
    CHANGE_OF_ADDRESS_MODAL,
    DEATH_MODAL,
    DENIED_MEDICAID_CHIP_MODAL,
    DIVORCE_AND_SEPARATION_MODAL,
    LOSS_COVERAGE_MODAL,
    MARRIAGE_MODAL,
    NATIVE_AMERICANS_MODAL
};